///<reference path="./Event.ts"/>

namespace com.enirva.event
{
	export class EventDispatcher
	{
		private listeners: Array<Object>;

		private enterFrameFunc: Function;

		private enterFrameTimer: number;

		private intervalTimer: number;

		public useDeltaTime: boolean;

		private isEnterFrame: boolean;
		
		
		constructor()
		{
			this.listeners = new Array();
			this.useDeltaTime = false;
		}


		/*
		 * リスナーを登録する
		 */
		public addEventListener(type: string, func: Function, scope:any = null): void
		{
			if (!this.listeners)
			{
				this.listeners = new Array();
			}

			this.listeners.push({ type: type, func: func, scope: scope });
		}
		

		/*
		 * リスナーを削除する
		 */
		public removeEventListener(type: string, func: Function): void
		{
			var ls: Array<Object> = this.listeners;
			var tmp: Array<Object> = new Array();

			for (var i: number = 0, ln: number = ls.length; i < ln; i++)
			{
				var ob: any = ls[i];

				if (ob.type != type || ob.func != func)
				{
					tmp.push(ob);
				}
			}

			this.listeners = tmp;
		}
		
		
		/*
		 * 全ての登録リスナーを削除する
		 */
		public removeAllEventListener():void
		{
			this.listeners = new Array();
		}
		

		/*
		 * リスナーを発行する
		 */
		public dispatchEvent(evt: any)
		{
			var ls: Array<Object> = this.listeners;
			if (!ls) return;
			
			for (var i: number = 0, ln: number = ls.length; i < ln; i++)
			{
				var ob: any = ls[i];

				if (ob.type == evt.type)
				{
					(evt as Event).target = this;
					
					if (ob.scope)
					{
						ob.func.call(ob.scope, evt);
					}
					else
					{
						ob.func(evt);
					}
					
					//break;
				}
			}
		}
		
		
		/*
		 * EnterFrame実行
		 */
		public set onEnterFrame(func: Function)
		{
			/*
			if (this.enterFrameFunc)
			{
				this.deleteEnterFrame;
			}
			*/

			this.enterFrameFunc = func;
			var scope: EventDispatcher = this;

			if (this.useDeltaTime)
			{
				//デルタタイムあり
				if (!this.isEnterFrame)
				{
					this.isEnterFrame = true;
					var current: number = new Date().getTime();

					(function loop()
					{
						if (!scope.enterFrameFunc)
						{
							scope.isEnterFrame = false;
							return;
						}

						var tmp: number = new Date().getTime();
						var deltaTime = tmp - current;
						if (deltaTime < 0)
						{
							deltaTime = 1;
						}
						scope.enterFrameFunc(deltaTime);
						current = tmp;
						scope.intervalTimer = requestAnimationFrame(() => loop());
					})();
				}
			}
			else
			{
				//デルタタイムなし
				if (!this.isEnterFrame)
				{
					this.isEnterFrame = true;

					(function loop()
					{
						if (!scope.enterFrameFunc)
						{
							scope.isEnterFrame = false;
							return;
						}
						scope.enterFrameFunc();
						scope.intervalTimer = requestAnimationFrame(() => loop());
					})();
				}
			}
		}

		
		/*
		 * EnterFrame停止
		 */
		public get deleteEnterFrame(): boolean
		{
			this.isEnterFrame = false;
			this.enterFrameFunc = null;
			cancelAnimationFrame(this.intervalTimer);
			this.intervalTimer = null;
			return true;
		}
	}
}

